export default __webpack_public_path__ + "static/media/lounge.e7fda8de.jpg";